import {
  css, Global, ThemeProvider,
} from '@emotion/react';
import {
  createContext, type ReactNode, useContext,
} from 'react';
import { OverlayLoaderComponent } from '~/_shared/components/overlay/overlayLoader.component';
import { lightTheme } from '~/_shared/themes/light.theme';
import type { Theme } from '~/_shared/themes/theme.model';

const globalStyle = (theme: Theme) => css`
  @page {
    size: A4 portrait;
    margin: 2mm;
    background: ${theme.reportColors.backgroundPrimary};
  }
  body {
    background: ${theme.reportColors.backgroundPrimary};
    color: ${theme.reportColors.textPrimary};
  }
  #root {
    overflow: visible !important;
  }
`;
/**
 * This is a ratio that allows conversion from mm to px. It was determined empirically
 */
const scaleMmToFitPage = (size: number) => `${270 / 210 * size}mm`;

const wrapperStyle = css({
  position: 'relative',
  width: scaleMmToFitPage(190),
  margin: '8mm auto 0',
  boxSizing: 'border-box',
  paddingBottom: 20,
});

const loaderStyle = css({
  position: 'fixed',
});

type ExportReportPrintPageWrapperProps = Readonly<{
  children: ReactNode;
  isLoading?: boolean;
}>;

// The BE prints the page once `window.isReportFullyLoaded` is set, so the loader is only shown when explicitly enabled (e.g. on the dev print page).
export const ExportReportPrintPageLoaderContext = createContext(false);

export const ExportReportPrintPageWrapperComponent = ({ children, isLoading }: ExportReportPrintPageWrapperProps) => {
  const isLoaderEnabled = useContext(ExportReportPrintPageLoaderContext);

  return (
    <ThemeProvider theme={lightTheme}>
      <div css={wrapperStyle}>
        <Global styles={globalStyle} />
        {children}
        {isLoaderEnabled && isLoading && <OverlayLoaderComponent css={loaderStyle} />}
      </div>
    </ThemeProvider>
  );
};
